export default __webpack_public_path__ + "static/media/WhaleShark.07a3b3a1.jpg";